import firebase from 'firebase/app'
import 'firebase/auth'

const baseUrl = process.env.REACT_APP_API_URL

async function goToCustomerDashboardAsync( user ) {
  let currentUser = user;
  if ( !currentUser ) {
    currentUser = firebase.auth().currentUser;
  }
  const idToken = await currentUser.getIdToken();
  return fetch(
    `${baseUrl}/stripePortalUrl`,
    {
      method : 'POST',
      headers : {
        'Content-type' : 'application/json',
        Authorization : `Bearer ${idToken}`,
      },
    },
  ).then(
    ( res ) => res.json(),
  ).then( ( result ) => {
    if ( result.url ) {
      console.log( 'opening ', result.url )
      window.open( result.url )
    }
    return null;
  } )
}

async function refreshSubscriptionInfo( user ) {
  let currentUser = user;
  if ( !currentUser ) {
    currentUser = firebase.auth().currentUser;
  }
  const idToken = await currentUser.getIdToken();
  console.debug( `hitting ${baseUrl}/refreshSubscriptionInfo` )
  const result = await fetch(
    `${baseUrl}/refreshSubscriptionInfo`,
    {
      method : 'POST',
      headers : {
        'Content-type' : 'application/json',
        Authorization : `Bearer ${idToken}`,
      },
    },
  );

  if ( result ) {
    if ( result.status >= 400 ) {
      const errorMessage = ( await result.json() ).error.message;
      console.error( 'Failed to refresh subscription info: ', errorMessage );
      throw new Error( errorMessage );
    }
  }
}

async function createCheckoutSession() {
  const user = firebase.auth().currentUser;
  const idToken = await user.getIdToken();
  return fetch(
    `${baseUrl}/startCheckoutSession`,
    {
      method : 'POST',
      headers : {
        'Content-type' : 'application/json',
        Authorization : `Bearer ${idToken}`,
      },
      body : JSON.stringify( {
        baseUrl : process.env.REACT_APP_HOSTED_SITE_URL,
      } ),
    },
  ).then(
    ( res ) => {
      console.log( 'returning checkout session' );
      return res.json();
    },
  );
}

export {
  goToCustomerDashboardAsync,
  refreshSubscriptionInfo,
  createCheckoutSession,
};

export default {
  goToCustomerDashboardAsync,
  refreshSubscriptionInfo,
  createCheckoutSession,
};
